import React, { Component } from "react";
import { Helmet } from "react-helmet";
import logo from "../../assets/logo.png";
import Navbar from "../Navbar/Navbar";
import GrievancePolicyCard from "./GrievancePolicyCard";
import BottomBar from "../BottomBar/BottomBar";
class GrievancePolicy extends Component {
  render() {
    return (
   
        <section id='grievancepolicy' className="main">
          <Helmet>
            <title>Grievance Policy | MoneyMonk</title>
            <meta name="description" content="Read MoneyMonk's grievance redressal policy and learn how to raise a complaint with our RBI Registered NBFC." />
            <link rel="canonical" href="https://moneymonkapp.in/grievancepolicy" />
          </Helmet>
          <Navbar imageData={logo} />
          <GrievancePolicyCard />
          <BottomBar />
        </section>

    );
  }
}

export default GrievancePolicy;
